// covered-by: frontends/carrie/src/ask-v2/home/__tests__/canRenderApprove.test.ts
import { type AskPunttActionCard } from "@mg/schemas/src/christo/askPunttBriefing";

/** Horvitz: never restyle a preview/suggestion as Approve. */
export function canRenderApprove(card: AskPunttActionCard): boolean {
  return card.primary === "approve" && card.confidence === "confident";
}
